import { render, staticRenderFns } from "./CropperBox.vue?vue&type=template&id=0ccb0fe8&scoped=true"
import script from "./CropperBox.vue?vue&type=script&lang=js"
export * from "./CropperBox.vue?vue&type=script&lang=js"
import style0 from "./CropperBox.vue?vue&type=style&index=0&id=0ccb0fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb0fe8",
  null
  
)

export default component.exports